import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useState, useEffect, useRef, MutableRefObject } from 'react';
import EfImg from '@elem/ui/ef-img';
// import EfVideo from '@elem/ui/ef-video';
import EFVideo from '@/components/UI/EFVideo';
import { roundFloat, transformToBob } from '@/utils/common';
import { handleDynamicPath } from '@/utils/handleDynamicPath';

export default function TheComp() {
    const { t: t1 } = useLang('rapid.AniBCard1');
    const { t: t2 } = useLang('rapid.AniBCard2');
    const [enter1, setEnter1] = useState(false);
    const [enter2, setEnter2] = useState(false);
    const [active, setActive] = useState(0);
    const [isPC, setIsPC] = useState(false);
    const videoPCRef = useRef(null);
    const videoH5Ref = useRef(null);
    const videoAutoCarRef = useRef<MutableRefObject<any>>(null);
    const [sources, setSources] = useState<string[] | null>(null);

    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729602706652/pc_Charge.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729602693059/m_Charge.jpg',
            tab: t1('a_tab'),
            text1: '', //t1('a_text1'),
            text2: t1('a_text2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729602693244/pc_Recharge.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729602693422/m_Recharge.jpg',
            tab: t1('b_tab'),
            text1: t1('b_text1'),
            text2: t1('b_text2'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsPC(window.innerWidth >= 768);
            AniContainer.create({
                triggerElement: '.rapid .rapid-C',
                triggerHook: 1,
                offset: '150%',
                onEnter: () => setEnter1(true),
            });
            AniContainer.create({
                triggerElement: `.rapid .${css.comp}`,
                triggerHook: 1,
                offset: '125%',
                duration: '325%',
                onEnter: () => setEnter2(true),
                onLeave: () => setEnter2(false),
            });
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            // const cls = isPC ? `.${css.comp} .s2 .ef-video-item-pc` : `.${css.comp} .s2 .vef-video-item-h5`;
            AniContainer.create({
                triggerElement: `.rapid .${css.comp}`,
                triggerHook: 1,
                offset: '125%',
                duration: '250%',
                onEnter: () => {
                    const video = isPC ? videoPCRef.current : videoH5Ref.current;
                    if (video) {
                        video.currentTime = 0;
                        video.play();
                    }
                },
                // onProcess: (process: number) => {
                //     // const video = cls ? (document.querySelector(cls) as HTMLVideoElement) : null;
                //     // const video = isPC ? videoPCRef.current : videoH5Ref.current;
                //     // if (video) {
                //     //     // video.removeAttribute('autoplay');
                //     //     video.currentTime = roundFloat((video?.duration || 0) * process, 2) || 0;
                //     // }
                //     // const video: any = videoAutoCarRef.current;
                //     // if (video) {
                //     //     const duration: number = video?.current?.duration;
                //     //     const currentTime = roundFloat(duration * process, 2) || 0;
                //     //     video?.setCurrentTime(currentTime);
                //     // }
                // },
                // onLazyLoad: async () => {
                //     try {
                //         const blobUrl = await transformToBob(
                //             // handleDynamicPath('/video/blade/detail/pc/cut_01.mp4'),
                //             // handleDynamicPath('/video/blade/detail/pc/cut_01.webm'),
                //             handleDynamicPath('https://websiteoss.ecoflow.com/upload/video/1729655205149/pc.mp4'),
                //             handleDynamicPath('https://websiteoss.ecoflow.com/upload/video/1729655205149/pc.mp4'),
                //         );
                //         // isPC
                //         //     ? 'https://websiteoss.ecoflow.com/upload/video/1729655205149/pc.mp4'
                //         //     : 'https://websiteoss.ecoflow.com/upload/video/1729655205192/m.mp4',
                //         if (video) {
                //             video.current.src = blobUrl;
                //         }
                //     } catch (e) {
                //         setSources([
                //             'https://websiteoss.ecoflow.com/upload/video/1729655205149/pc.mp4',
                //             'https://websiteoss.ecoflow.com/upload/video/1729655205149/pc.mp4',
                //         ]);
                //         // setSources(['/video/blade/detail/pc/cut_01.webm', '/video/blade/detail/pc/cut_01.mp4']);
                //     }
                // },
                // lazyHook: 0,
            });
        }
    }, [isPC]);

    return (
        <div className={css.comp}>
            <div className={`sticky-box ${enter2 ? 'enter2' : ''}`}>
                <div className="s1">
                    <ul className="items">
                        {items?.map((item: any, k: number) => (
                            <li className={`item item${k + 1} ${active === k ? 'active' : ''}`}>
                                <div className="item-img">
                                    <EfImg pc={item.pc} pad={item.pc} h5={item.h5} />
                                    {item?.text1 && <p className="text text1">{item.text1}</p>}
                                    {item?.text2 && <p className="text text2">{item.text2}</p>}
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className="info">
                        <ul className="tabs">
                            {items?.map((item: any, k: number) => (
                                <li className={`tab tab${k + 1} ${active === k ? 'active' : ''}`} onClick={() => setActive(k)}>
                                    {item.tab}
                                </li>
                            ))}
                        </ul>
                        <p className="title">
                            {t1.rich('title', {
                                sup: (text: string) => <sup className="sup">{text}</sup>,
                            })}
                        </p>
                        <p className="desc">{t1('desc')}</p>
                    </div>
                </div>
                <div className={`s2 ${enter1 ? 'enter1' : ''}`}>
                    <div className="video">
                        {enter1 && (
                            // <EfVideo
                            //     poster={'https://websiteoss.ecoflow.com/upload/image/1729602706652/pc_Charge.jpg'}
                            //     posterH5={'https://websiteoss.ecoflow.com/upload/image/1729602693059/m_Charge.jpg'}
                            //     pc={'https://websiteoss.ecoflow.com/upload/video/1729655205149/pc.mp4'}
                            //     pad={'https://websiteoss.ecoflow.com/upload/video/1729655205149/pc.mp4'}
                            //     h5={'https://websiteoss.ecoflow.com/upload/video/1729655205192/m.mp4'}
                            //     autoPlay={true}
                            //     playsInline
                            //     muted
                            // />
                            <>
                                {/* <EFVideo ref={videoAutoCarRef} className="video" autoPlay={false} loop={false} sources={sources} /> */}
                                {isPC ? (
                                    <video
                                        ref={videoPCRef}
                                        src="https://websiteoss.ecoflow.com/upload/video/1729655205149/pc.mp4"
                                        poster={'https://websiteoss.ecoflow.com/upload/image/1729602706652/pc_Charge.jpg'}
                                        className="ef-video-item-pc"
                                        autoPlay={false}
                                        muted
                                        playsInline
                                        pre-load="auto"
                                        width="100%"
                                        heigh="100%"
                                    />
                                ) : (
                                    <video
                                        ref={videoH5Ref}
                                        src="https://websiteoss.ecoflow.com/upload/video/1729655205192/m.mp4"
                                        poster={'https://websiteoss.ecoflow.com/upload/image/1729602693059/m_Charge.jpg'}
                                        className="ef-video-item-h5"
                                        autoPlay={false}
                                        muted
                                        playsInline
                                        pre-load="auto"
                                        width="100%"
                                        heigh="100%"
                                    />
                                )}
                            </>
                        )}
                    </div>
                    <div className="info">
                        <p className="title">
                            {t2.rich('title', {
                                sup: (text: string) => <sup className="sup">{text}</sup>,
                            })}
                        </p>
                        <p className="desc">{t2('desc')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
